<div class="msg-date-line">
  <span>{{date}}</span>
</div>
